import { render, staticRenderFns } from "./ProductMainPhoto.vue?vue&type=template&id=9e270c8c&"
import script from "./ProductMainPhoto.vue?vue&type=script&lang=js&"
export * from "./ProductMainPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports